import { useState, useEffect } from "react";
import { Button, Box, TextField, Typography } from "@mui/material";
import { UseFestivalManagment } from "./UseFestivalManagment";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import DiscountGrid from "./DiscountGrid";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";

export default function EditFestival(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    getFestivalByID,
    updateFestival,
    validate,
    startFestival,
    finishFestival,
  } = UseFestivalManagment();
  const { isSmall } = useBreakpoints();
  const [valueStart, setValueStart] = useState();
  const [valueEnd, setValueEnd] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const { toSolar } = require("jdate-convert");
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });

  const [state, setState] = useState({
    id: undefined,
    title: undefined,
    startDate: undefined,
    endDate: undefined,
    stateID: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    startDate: false,
    endDate: false,
  });

  useEffect(() => {
    if (location.state.id) {
      getFestivalByID(location.state.id, (festival) => {
        setState({
          id: festival.id,
          title: festival.title,
          stateID: festival.stateID,
          startDate: festival.startDate.split("T")[0],
          endDate: festival.endDate.split("T")[0],
        });
      });
    }
  }, [location.state]);

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setState({ ...state, startDate: newValueStart });
  }, [valueStart]);

  useEffect(() => {
    let newValueEnd = valueEnd?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, endDate: newValueEnd });
  }, [valueEnd]);

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/festivalmanagment" },
          { name: "ویرایش جشنواره", url: "/festivalmanagment/editFestival" },
        ],
      }}
    >
      {state ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            sx={{ display: "flex", gap: 2 }}
            gridColumn={isSmall ? "span 12" : "span 7"}
          >
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              onChange={setValueStart}
              value={state && state.startDate ? toSolar(state.startDate) : ""}
              render={
                <TextField
                  sx={{ pr: 2, input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="تاریخ شروع"
                  error={errorState.startDate}
                />
              }
            />
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={state && state.endDate ? toSolar(state.endDate) : ""}
              // value={valueEnd}
              onChange={setValueEnd}
              render={
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  label="تاریخ پایان"
                  size="small"
                  fullWidth
                  error={errorState.endDate}
                />
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            {state.stateID == 0 || state.stateID == 2 ? (
              <Button
                sx={{ width: "100px" }}
                variant="contained"
                onClick={() => {
                  setCheckState({
                    show: true,
                    id: state.id,
                    name: "شروع جشنواره " + state.title,
                    type: "start",
                  });
                }}
              >
                شروع
              </Button>
            ) : state.stateID == 1 ? (
              <Box>
                <Button
                  sx={{ width: "100px", mr: 2 }}
                  variant="contained"
                  // color="error"
                  onClick={() => {
                    setCheckState({
                      show: true,
                      id: state.id,
                      name: "به‌روزرسانی جشنواره " + state.title,
                      type: "update",
                    });
                  }}
                >
                  به‌روزرسانی
                </Button>
                <Button
                  sx={{ width: "100px" }}
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setCheckState({
                      show: true,
                      id: state.id,
                      name: "اتمام جشنواره " + state.title,
                      type: "finish",
                    });
                  }}
                >
                  اتمام
                </Button>
              </Box>
            ) : (
              ""
            )}
            <Button
              sx={{ mx: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateFestival(state, () => {
                    navigate("/festivalmanagment", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/festivalmanagment", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn="span 12">
            <Typography sx={{ mb: 2 }} color="secondary">
              تخفیفات
            </Typography>
            <DiscountGrid festivalID={location.state.id} />
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          if (checkState.type == "start") {
            let model = {
              ID: checkState.id,
              Restart: state.stateID == 2 ? true : false,
            };
            setProgress(true);
            startFestival(model, () => {
              getFestivalByID(state.id, (festival) => {
                setState({
                  id: festival.id,
                  title: festival.title,
                  stateID: festival.stateID,
                  startDate: festival.startDate.split("T")[0],
                  endDate: festival.endDate.split("T")[0],
                });
              });
            });
          } else if (checkState.type == "finish") {
            let model = {
              ID: checkState.id,
            };
            setProgress(true);

            finishFestival(model, () => {
              getFestivalByID(state.id, (festival) => {
                setState({
                  id: festival.id,
                  title: festival.title,
                  stateID: festival.stateID,
                  startDate: festival.startDate.split("T")[0],
                  endDate: festival.endDate.split("T")[0],
                });
              });
            });
          } else if (checkState.type == "update") {
            let model = {
              ID: checkState.id,
              Restart: true,
            };
            setProgress(true);
            startFestival(model, () => {
              getFestivalByID(state.id, (festival) => {
                setState({
                  id: festival.id,
                  title: festival.title,
                  stateID: festival.stateID,
                  startDate: festival.startDate.split("T")[0],
                  endDate: festival.endDate.split("T")[0],
                });
              });
            });
          }
        }}
      />
    </Detail>
  );
}
